import * as React from 'react';

function SvgNotificationsOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M15.076 18.154v.77a3.077 3.077 0 01-6.153 0v-.77m11.33-1.566c-1.234-1.511-2.106-2.28-2.106-6.446 0-3.815-1.948-5.174-3.551-5.834a.857.857 0 01-.479-.508C13.837 2.843 13.047 2 12 2c-1.049 0-1.838.844-2.116 1.801a.848.848 0 01-.478.507c-1.605.66-3.552 2.015-3.552 5.834-.002 4.166-.874 4.935-2.108 6.446-.512.626-.064 1.566.831 1.566h14.85c.89 0 1.335-.943.826-1.566z" })));
}

export default SvgNotificationsOutline;
